import {defineDimension, createBooleanMap} from '@webflow-platform/abilities';
import type {
  BetaFeatureFlag,
  BetaFeatureFlags,
} from '@packages/systems/core-constants';

type Config = Partial<Record<BetaFeatureFlag, boolean>>;
type Stores = {BetaFeatureStore?: BetaFeatureFlags};

export const betaFlagsDimension = defineDimension<Config, Stores>()({
  key: 'betaFlags',
  isValid({BetaFeatureStore}, betaFlagsToCheck) {
    if (!BetaFeatureStore) return true;

    return Object.entries(betaFlagsToCheck).every(
      ([flag, expectation]) =>
        Boolean(BetaFeatureStore[flag as BetaFeatureFlag]) === expectation
    );
  },
  fragments: {
    betaFlagsEnabled: (...flags: BetaFeatureFlag[]) =>
      createBooleanMap(flags, true),
    betaFlagsDisabled: (...flags: BetaFeatureFlag[]) =>
      createBooleanMap(flags, false),
  },
  testMatrix(addAxis, config) {
    for (const flag of Object.keys(config)) {
      addAxis((addCase) => {
        addCase({label: flag, state: {BetaFeatureStore: {[flag]: true}}});
        addCase({
          label: `!${flag}`,
          state: {BetaFeatureStore: {[flag]: false}},
        });
      });
    }
  },
});

export const {betaFlagsEnabled, betaFlagsDisabled} =
  betaFlagsDimension.fragments;
